<app-menu-template3>
  <main>
    <button type="button" class="btn btn-primary btn-comment" (click)="onOpenModalComments()"
      *ngIf="authService.getTipoUser() !== tipo_prestador">Comentarios</button>
    <section class="row ml-5 mr-5 mt-4 mb-3 rounded shadow-sm bg-white">
      <header class="row d-flex align-items-center w-100 p-4">
        <div class="col-sm-12 col-md-4 d-flex flex-row">
          <img src="/assets/icons/info-establecimiento.png" class="ml-5 d-inline-block rounded-circle" alt=""
            height="38">
          <label class="ml-3 small text-muted mb-0">Nombre<br><strong
              class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.razon_social}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Número RNT<br><strong
              class="h6 text-dark font-weight-bold">{{datoSolicitudSharedModel.data.codigo_rnt}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Número de radicación<br><strong
              class="h6 text-dark font-weight-bold">{{datoSolicitudSharedModel.data.numero_radicacion}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Tipo de solicitud<br><strong
              class="h6 text-dark font-weight-bold">{{datoSolicitudSharedModel.data.descripcion_tipo_solicitud}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Estado solicitud<br><strong
              class="h6 text-dark font-weight-bold">{{datoSolicitudSharedModel.data.descripcion_estado_solicitud}}</strong></label>
          <ng-container
            *ngIf="(authService.getRolUser(tipo_funcionario)) && datoSolicitudSharedModel.data.flag_historico !== true && datoSolicitudSharedModel.data.flag_consulta !== true">
            <img src="../../../../../assets/icons/edit_perfil.png"
              class="d-inline-block align-top position-absolute z-index pointer ml-2" alt="" height="40" width="40"
              (click)="onEstados()">
          </ng-container>
          <app-ayudas [ayuda]="ayudaService.detalleSolicitud"></app-ayudas>
        </div>
      </header>
    </section>
    <article class="row ml-5 mr-5 mt-3 mb-3 rounded shadow-sm bg-white">
      <header class="col-1 d-flex flex-column">
        <section class="row d-flex justify-content-center">
          <div class="col-12 text-center pt-3" routerLinkActive="active">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/establecimientos']">
              <img src="../../../../../assets/icons/rnt.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">RNT</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
              *ngIf=" datoSolicitudSharedModel.data.tipo_solicitud_id === reactivacion">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/informacion']">
              <img src="../../../../../assets/icons/informacion.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">
                Información 
                de 
                Reactivación
              </p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
            *ngIf="datoSolicitudSharedModel.data.tipo_rnt_id !== guia &&
            datoSolicitudSharedModel.data.tipo_solicitud_id === renovacion
          || datoSolicitudSharedModel.data.tipo_solicitud_id === actualizacion
          || datoSolicitudSharedModel.data.tipo_solicitud_id === inscripcion
          || (datoSolicitudSharedModel.data.estado_rnt_id === estado_suspendido_por_no_renovar &&  
          datoSolicitudSharedModel.data.tipo_solicitud_id ===reactivacion)">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/capacidad']">
              <img src="../../../../../assets/icons/capacidad.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Capacidad</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
            *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === inscripcion
          || datoSolicitudSharedModel.data.tipo_solicitud_id === renovacion
          || datoSolicitudSharedModel.data.tipo_solicitud_id === actualizacion
          || (datoSolicitudSharedModel.data.estado_rnt_id === estado_suspendido_por_no_renovar &&  
          datoSolicitudSharedModel.data.tipo_solicitud_id ===reactivacion)">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/documentos']">
              <img src="../../../../../assets/icons/docs.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Requisitos</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
            *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === renovacion 
            || (datoSolicitudSharedModel.data.estado_rnt_id === estado_suspendido_por_no_renovar &&  
            datoSolicitudSharedModel.data.tipo_solicitud_id ===reactivacion)">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/encuesta-funcionario']">
              <img src="../../../../../assets/icons/encuesta.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Encuesta</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active" 
          *ngIf="(datoSolicitudSharedModel.data.tipo_solicitud_id === renovacion || 
                 (datoSolicitudSharedModel.data.estado_rnt_id === estado_suspendido_por_no_renovar &&  
                datoSolicitudSharedModel.data.tipo_solicitud_id ===reactivacion))
            && informacionEstablecimiento.aplica_pago_parafiscales
            && !datoSolicitudSharedModel.data.excepcion_municipio_pago_fontur">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/parafiscales-funcionario']">
              <img src="../../../../../assets/icons/parafiscales.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Parafiscales</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
            *ngIf="(datoSolicitudSharedModel.data.tipo_solicitud_id === renovacion ||
            (datoSolicitudSharedModel.data.estado_rnt_id === estado_suspendido_por_no_renovar &&  
            datoSolicitudSharedModel.data.tipo_solicitud_id ===reactivacion))
          && (datoSolicitudSharedModel.data.tipo_rnt_id === establecimiento || datoSolicitudSharedModel.data.tipo_rnt_id === inmueble)
          && informacionEstablecimiento.respuesta_validacion_fontur && (!informacionEstablecimiento.aplica_pago_parafiscales || informacionEstablecimiento.supera_pago_parafiscales)">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/fontur']">
              <img src="../../../../../assets/icons/fontur.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Fontur</p>
            </a>
          </div>
          <div class="col-12 text-center pt-3" routerLinkActive="active"
            *ngIf="datoSolicitudSharedModel.data.tipo_solicitud_id === suspencion ||
          datoSolicitudSharedModel.data.tipo_solicitud_id === cancelacion ||
          datoSolicitudSharedModel.data.tipo_solicitud_id === reactivacionAnticipada">
            <a class="nav-item nav-link p-0 " [routerLink]="['/detalle-solicitud/informacion']">
              <img src="../../../../../assets/icons/informacion.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">Información</p>
            </a>
          </div>
        </section>
      </header>
      <section class="col-11">
        <router-outlet></router-outlet>
      </section>
    </article>
  </main>
</app-menu-template3>
